import { render } from "./AllergenList.vue?vue&type=template&id=39133b62&scoped=true"
import script from "./AllergenList.vue?vue&type=script&lang=js"
export * from "./AllergenList.vue?vue&type=script&lang=js"

import "./AllergenList.vue?vue&type=style&index=0&id=39133b62&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39133b62"

export default script